var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var HiddenComponent = /** @class */ (function (_super) {
    __extends(HiddenComponent, _super);
    function HiddenComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    HiddenComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    HiddenComponent.prototype.ngOnChanges = function (changes) {
        if (this.col.controlType === 'select2ajax') {
            if (this.val && typeof this.val.code !== 'undefined') {
                this.val = this.val.code;
                _super.prototype.onChange.call(this, this.val);
            }
        }
    };
    HiddenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-hidden',
                    template: '<input type="hidden" name="{{ colKey }}" value="{{ val }}">',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    HiddenComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return HiddenComponent;
}(ColumnBaseComponent));
export { HiddenComponent };
//# sourceMappingURL=hidden.component.js.map